import React from 'react';
import { Link } from 'react-router-dom';
import './error.css';

const Error = () => {
  return (
    <main className="error_page">
      <section className="error_card">
        <p className="error_code">404</p>
        <h1>Page not found</h1>
        <span>The page you are looking for does not exist or has been moved.</span>

        <div className="error_actions">
          <Link className="error_primary_link" to="/dashboard">
            Go to Dashboard
          </Link>
          <Link className="error_secondary_link" to="/">
            Back to Login
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Error;
